/**
 * Internal dependencies
 */
const metadata = {
  $schema: "https://schemas.wp.org/trunk/block.json",
  apiVersion: 2,
  name: "core/post-author-biography",
  title: "Post Author Biography",
  category: "theme",
  description: "The author biography.",
  textdomain: "default",
  attributes: {
    textAlign: {
      type: "string"
    }
  },
  usesContext: ["postType", "postId"],
  supports: {
    spacing: {
      margin: true,
      padding: true
    },
    color: {
      gradients: true,
      link: true,
      __experimentalDefaultControls: {
        background: true,
        text: true
      }
    },
    typography: {
      fontSize: true,
      lineHeight: true,
      __experimentalFontFamily: true,
      __experimentalFontWeight: true,
      __experimentalFontStyle: true,
      __experimentalTextTransform: true,
      __experimentalLetterSpacing: true,
      __experimentalDefaultControls: {
        fontSize: true
      }
    }
  }
};
import edit from './edit';
/**
 * WordPress dependencies
 */

import { postAuthor as icon } from '@wordpress/icons';
const {
  name
} = metadata;
export { metadata, name };
export const settings = {
  icon,
  edit
};
//# sourceMappingURL=index.js.map